import React, { useCallback, useState } from 'react';
import { css } from '@emotion/react';
import { IconButton, Menu, MenuItem, Tooltip, ListItemText } from '@material-ui/core';
import MoreVertIcon from '@material-ui/icons/MoreVert';

const HiddenColumnsRestoreHeader = ({ getHiddenEntries, onShowColumn }) => {
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);

    const entries = getHiddenEntries?.() || [];
    const hasHidden = entries.length > 0;

    const handleOpen = useCallback((e) => {
        e.stopPropagation();
        setAnchorEl(e.currentTarget);
    }, []);

    const handleClose = useCallback((e) => {
        e?.stopPropagation?.();
        setAnchorEl(null);
    }, []);

    const handleShow = useCallback(
        (columnId) => (e) => {
            e.stopPropagation();
            onShowColumn?.(columnId);
            setAnchorEl(null);
        },
        [onShowColumn]
    );

    return (
        <div
            css={css`
                display: flex;
                align-items: center;
                justify-content: center;
                width: 100%;
                height: 100%;
            `}
        >
            <Tooltip title="Show hidden columns" placement="top" arrow>
                <IconButton
                    aria-label="show hidden columns"
                    size="small"
                    onClick={handleOpen}
                    css={css`
                        padding: 6px;
                    `}
                >
                    <MoreVertIcon fontSize="small" />
                </IconButton>
            </Tooltip>
            <Menu
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                keepMounted
                getContentAnchorEl={null}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                transformOrigin={{ vertical: 'top', horizontal: 'right' }}
            >
                {hasHidden ? (
                    entries.map(({ id, label }) => (
                        <MenuItem key={id} onClick={handleShow(id)} dense>
                            <ListItemText primary={`Show ${label}`} />
                        </MenuItem>
                    ))
                ) : (
                    <MenuItem dense disabled>
                        <ListItemText primary="No hidden columns" />
                    </MenuItem>
                )}
            </Menu>
        </div>
    );
};

export default HiddenColumnsRestoreHeader;
